import { ShieldCheck, Truck, Heart, MessageCircle, PawPrint, Wallet } from "lucide-react";
import { useLang } from "../lib/i18n";

const ICONS = [ShieldCheck, Truck, MessageCircle, Heart, Wallet, PawPrint];

export default function About() {
  const { t } = useLang();
  const trust = t("about.trust");
  return (
    <section id="about" className="py-16 sm:py-24" style={{ background: "#0F172A", color: "#fff" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.2em] text-yellow-300">{t("about.tag")}</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-2">{t("about.title")}</h2>
          <p className="text-slate-300 mt-3">{t("about.intro")}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {trust.map(([title, desc], i) => {
            const Icon = ICONS[i] || PawPrint;
            return (
              <div
                key={i}
                className="rounded-2xl p-5 fade-up"
                style={{ background: "#1E293B", border: "2px solid #FDE047" }}
                data-testid={`trust-${i}`}
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ background: "#FDE047", color: "#0F172A" }}
                >
                  <Icon size={22} />
                </div>
                <h3 className="font-display text-xl font-semibold mt-4">{title}</h3>
                <p className="text-sm text-slate-300 mt-1">{desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
